/**
 * @author - steves165
 *
 *
 */
(function() {
    'use strict';

    /**
    * REST functions namespace.
    *
    * @type {{propertyExtract: Function, nodePropertySplit: Function}}
    */
    var restFuncs = {
        /**
         * Take the lowest level node, extracts the property values and adds
         * them with a key of the property name to an object which is returned.
         *
         * @param node
         * @returns Object of properties
         */
        propertyExtract: function(node) {
            if (node.properties.length > 0) {
                var field = {};
                for (var i = 0; i < node.properties.length; i++) {
                    if (node.properties[i].multiple) {
                        field[node.properties[i].name] = [];
                        for (var j = 0; j < node.properties[i].values.length; j++) {
                            field[node.properties[i].name].push(node.properties[i].values[j]);
                        }
                    } else {
                        field[node.properties[i].name] = node.properties[i].values[0];
                    }
                }
                return field;
            }
        },
        /**
         * Takes a list of nodes and a scope then extracts
         * the properties from the nodes and attaches them to the scope.
         *
         * @param nodes
         * @param $scope
         */
        nodePropertySplit: function(nodes, $scope, key) {
            $scope[key] = nodes.map(function(node) {
                return restFuncs.propertyExtract(node);
            });
        }
    };

    /*global angular*/
    angular.module('vhols')

        .controller('DestinationsPageController', ['$rootScope', '$scope', 'destinationsService', 'deviceDetection', '$window', function ($rootScope, $scope, destinationsService, deviceDetection, $window) {
            $scope.limit = 10;
            $scope.getDestinations = function (destinationName) {
                destinationsService.getPageProps(destinationName, 20).then(function (data) {

                    $scope.destination = data;
                    restFuncs.nodePropertySplit($scope.destination.nodes, $scope, 'events');

                    $scope.groupedEvents = $scope.eventsGrouping();
                });
            };

            $scope.eventsGrouping = function() {
                var events = [];
                var months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

                if ($scope.events && $scope.destination.nodes) {
                    angular.forEach(months, function(data) {
                        var month = [];
                        if ($scope.events) {
                            angular.forEach($scope.events, function(event) {
                                if (event.monthSelect === data) {
                                    month.push({ title: event.eventTitle, content: event.eventContent });
                                }
                            });

                            events.push([data, month]);
                        }
                    });
                } else {
                    events.push(['No Events', [{ title: '', content: 'There are no events for this destination at the moment.' }]]);
                }

                return events;
            };

            $scope.changeDestination = function(apply) {
                $scope.getDestinations($scope.destinationSelectEvents);
                if (!apply) {
                    $scope.$apply();
                }
            };

            $scope.init = function(locationId, brandId) {
                $scope.locationId = locationId;
                $scope.brandId = brandId;
                $scope.device = deviceDetection.getDevice();

                var eventObj;

                if(typeof(Event) === 'function') {
                    eventObj = new Event('activate-hero');
                }else{
                    eventObj = document.createEvent('Event');
                    eventObj.initEvent('activate-hero', true, true);
                }

                $window.dispatchEvent(eventObj);

                if (locationId && brandId) {
                    initialiseSearchPanel({ locationId: locationId, businessContext: brandId, bookingType: 1 });
                }
            };

            // Initialise the search panel using the given parameters.
            function initialiseSearchPanel(params) {
                destinationsService.getLocationData(params).success(function(promise) {
                    if (promise.items && promise.items.length > 0) {
                        var criteria = {
                            selectedChildLocation: {
                                locationUrlDescription: promise.items[0].locationUrlDescription
                            },
                            selectedBookingType: {
                                brand: params.businessContext,
                                id: params.bookingType
                            }
                        };

                        $rootScope.$emit('SearchPanel:populate', criteria);
                    }
                });
            }
        }])

        .controller('SwipeScrollCtrl', function($scope, $element) {
            $scope.swipe = function(direction) {
                vhols.angEl($element[0].getElementsByClassName(direction)[0]).triggerHandler('click');
            };
        })

        .controller('CollapseController', function($scope) {
            $scope.isCollapsed = true;

            function collapse() {
                $scope.$evalAsync(function() {
                    $scope.isCollapsed = window.innerWidth < 768;
                    $scope.collapseText = $scope.isCollapsed ? 'Read more' : 'Read less';
                });
            }

            vhols.eventDebounce(function() {
                collapse();
            }, 'resize', window, 300);

            collapse();
        });
})();
